import { render, staticRenderFns } from "./insertUser.vue?vue&type=template&id=c45ee20a"
import script from "./insertUser.vue?vue&type=script&lang=js"
export * from "./insertUser.vue?vue&type=script&lang=js"
import style0 from "./insertUser.vue?vue&type=style&index=0&id=c45ee20a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports